module.exports = __webpack_public_path__ + "img/1.b0231df8.jpg";